<fullscreen-page>
    <content-column>
        <div class="d-flex flex-column flex-fill w-100 mx-auto overflow-hidden" slot="content">

            <div class="d-flex flex-column np-header">
                <div class="p-2 h2">Golden Record</div>
            </div>

            <div class="d-flex flex-column flex-fill min-vh-0">
                <div class="d-flex flex-row flex-fill gap-3 min-vh-0">
                    <div class="flex-grow-1 min-vh-0 overflow-auto ps-2">

                        <div class="d-flex flex-column gap-2 p-2 w-100">

                            <div *ngIf="goldenRecord"
                                 class="catalog-row">

                                <div class="catalog-row__drag">
                                    <i class="dx-icon-menu"></i>
                                </div>

                                <i class="icon-glyphicons-basic-425-crown golden-record-crown"></i>

                                <div class="catalog-row__main cursor-pointer"
                                     (click)="onNameClick(goldenRecord)">
                                    <div class="catalog-row__title">
                                        
                                        {{ goldenRecord.catalogName }}
                                    </div>
                                    <div class="catalog-row__subtitle">
                                        {{ goldenRecord.createdAt | date:'dd.MM.yyyy, HH:mm' }}
                                    </div>
                                </div>

                                <div class="catalog-row__actions" (click)="$event.stopPropagation()">
                                    <dx-button
                                        icon="overflow"
                                        stylingMode="text"
                                        type="default"
                                        (onClick)="openGoldenRecordMenu($event, goldenRecord)">
                                    </dx-button>
                                </div>
                            </div>

                            <ng-container *ngIf="goldenRecord && backups.length > 0">
                                <div class="catalog-row__subtitle fw-semibold px-1 pt-2">
                                    {{ 'Backups' | translate }}
                                </div>

                                <div *ngFor="let backup of backups"
                                     class="catalog-row catalog-row--muted">

                                    <div class="catalog-row__drag">
                                        <i class="dx-icon-menu"></i>
                                    </div>

                                    <i class="dx-icon-clock"></i>

                                    <div class="catalog-row__main">
                                        <div class="catalog-row__title">
                                            {{ backup.catalogName }}
                                        </div>
                                        <div class="catalog-row__subtitle">
                                            {{ backup.backUpTimeStamp | date:'dd.MM.yyyy, HH:mm' }}
                                        </div>
                                    </div>

                                    <div class="catalog-row__actions" (click)="$event.stopPropagation()">
                                        <dx-button
                                            icon="overflow"
                                            stylingMode="text"
                                            type="default"
                                            (onClick)="openBackupMenu($event, backup)">
                                        </dx-button>
                                    </div>
                                </div>
                            </ng-container>

                            <div *ngIf="!goldenRecord" class="d-flex justify-content-center align-items-center p-5">
                                {{ 'Keine Golden Records vorhanden' | translate }}
                            </div>

                        </div>

                        <dx-context-menu
                            #rowMenu
                            [dataSource]="currentMenuItems"
                            [width]="200"
                            [showEvent]="''"
                            [position]="{ my: 'left top', at: 'left bottom' }"
                            (onItemClick)="onMenuItemClick($event)">
                        </dx-context-menu>
                    </div>

                    <div class="min-vh-0 overflow-auto">
                        <np-inspect-container-catalog
                            [catalogId]="selectedCatalogId">
                        </np-inspect-container-catalog>
                    </div>
                </div>
            </div>
        </div>
    </content-column>
</fullscreen-page>
